import React from 'react';
import {FormControl} from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import {
  ApiButton,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from 'web-library';
import { SelectedUserInfo } from '../../../../pages/uniqueLink/AdminUniqueLink/model';
import {
  SendUniqueLinkEmailFormData,
  usePostAdminAppealSendEmail,
} from '../../../../api-refactored/appeal/usePostAdminAppealSendEmail';
import ControlledFormControlLabel
  from "web-library/stories/atom/FormControlLabel/ControlledFormControlLabel";

const useStyles = makeStyles()((theme) =>
({
  viewDetailsDialog: {
    '& .MuiPaper-root.MuiDialog-paper': {
      padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
      '& .MuiDialogTitle-root': {
        padding: `0 0 ${theme.spacing(2)} 0`,
      },
      '& .MuiDialogContent-root': {
        padding: `0 0 ${theme.spacing(3)} 0`,
      },
      '& .MuiDialogActions-root': {
        padding: 0,
      },
    },
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: theme.spacing(2),
  },
}));

interface GrantAccessModalProps {
  accountType: string;
  userInfo: SelectedUserInfo;
  modalState: boolean;
  onDialogClose: () => void;
  updateEmailStatus: (index: number, status: string, customMessage: string) => void;
}

const OpsAdminGrantAppealAccessModal = ({
  accountType,
  userInfo,
  modalState,
  onDialogClose,
  updateEmailStatus,
}: GrantAccessModalProps) => {
  const { t } = useTranslation();

  const { classes } = useStyles();

  const { handleSubmit, control } = useForm<SendUniqueLinkEmailFormData>({
    mode: 'onSubmit',
  });

  const {
    mutate: sendUniqueLinkEmailMutate,
    status: sendEmailStatus,
  } = usePostAdminAppealSendEmail({
    onSuccess: () => {
      updateEmailStatus(
        userInfo.index,
        'success',
        t('admin->>UniqueLink.EmailHasSent', { name: userInfo.name })
      );
      onDialogClose();
    },
    onError: (error) => {
      updateEmailStatus(
        userInfo.index,
        'error',
        error.response ? error.response.data.message! : error.message
      );
      onDialogClose();
    },
  });

  return (
    <Dialog
      id="unique-link-grant-access"
      open={modalState}
      maxWidth="sm"
      onClose={onDialogClose}
      className={classes.viewDetailsDialog}
    >
      <DialogTitle>{t('admin->>UniqueLink.GrantAccess')}</DialogTitle>

      <form
        onSubmit={handleSubmit((formData: SendUniqueLinkEmailFormData) => {
          sendUniqueLinkEmailMutate({
            isOfflinePayment: formData.isOfflinePayment,
            userType: accountType,
            uuid: userInfo.uuid,
            applicationType: 'APPEAL',
          });
        })}
      >
        <DialogContent>
          <Typography>{t('admin->>UniqueLink.GrantAccessSelectType')}</Typography>

          <FormControl >
            {accountType === 'CANDIDATES' && (
                <ControlledFormControlLabel
                    control={control}
                    defaultValue={false}
                    render={({onChange, value}) => <Checkbox onChange={e => onChange(e.target.checked)}
                                                             checked={value} />}
                    name="isOfflinePayment"
                    label={t('admin->>UniqueLink.OfflinePayment')}
                />
            )}
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button type="button" variant="text" onClick={onDialogClose}>
            {t('admin->>UniqueLink.Cancel')}
          </Button>

          <ApiButton type="submit" status={sendEmailStatus}>
            {t('admin->>UniqueLink.SendEmail')}
          </ApiButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};
export default OpsAdminGrantAppealAccessModal;
